import type { Settings } from "./types";

export const defaultSettings: Settings = {
  // appearance
  themeMode: "system",
  uiStyle: "liquidGlass",
  customGlassColor: "#6bffff",
  reduceMotion: false,

  // language
  language: "ru",

  // schedule source - GROUP (DU) is now PRIMARY
  scheduleSource: "group",
  selectedGroup: "SE-2417", // Default group for quick start

  // calendar
  icsUrl: "",
  autoRefreshMinutes: 30,

  // reminders
  remindersEnabled: true,
  deadlineRemindersEnabled: true,
  lessonRemindersEnabled: true,
  deadlineReminderMinutes: [1440, 180, 15],
  firstLessonReminderMinutes: 15,
  lessonReminderMinutes: [30, 10],
  quietHours: { from: 23, to: 8 },

  // hidden subjects
  hiddenCourses: [],

  // schedule filters
  hideOnlineLessons: false,
};
